import * as AppConstants from "AppConstants";
import { getDateInFormat } from "utils/dateUtil";

/**
 * Replaces memberId, fromDate and toDate placeholders with actual values from component states
 * GET /v1/api/leave-plans/by-member/{memberId}/between?fromDate={fromDate}&toDate={toDate}
 * Example URL to return: http://localhost:8081/v1/api/activities/member/10/between?fromDate=2022-11-01&toDate=2022-12-01
 * @returns leave-plans URL to be fired  
 * */
 export const getUrlForAllLeavePlansForMemberByDate = (memberId, fromDate, toDate) => {
    return AppConstants.GET_LEAVE_PLANS_BETWEEN_FOR_MEMBER_ENDPOINT
                        .replace(AppConstants.MEMBER_ID_PLACEHOLDER, memberId)
                        .replace(AppConstants.FROM_DATE_PLACEHOLDER, getDateInFormat(fromDate))
                        .replace(AppConstants.TO_DATE_PLACEHOLDER, getDateInFormat(toDate));
};

/**
 * 
 * POST /v1/api/leave-plans/save
 * Example URL to return: http://localhost:8081/v1/api/leave-plans/save
 * @returns leave-plans URL to be fired  
 * */
export const getUrlForAddLeavePlanForMember = () => {
    return AppConstants.ADD_LEAVE_PLAN_FOR_MEMBER_ENDPOINT;
};

export const getUrlForUpdateLeavePlanForMember = (leaveId) => {
    return AppConstants.UPDATE_LEAVE_PLAN_FOR_MEMBER_ENDPOINT
                        .replace(AppConstants.LEAVE_ID_PLACEHOLDER, leaveId);
};

/**
 * GET /v1/api/leave-plans/{id}
 * @returns leave-plans URL for a single leave plan by id
 */
export const getUrlForLeavePlanById = (leaveId) => {
    return AppConstants.GET_LEAVE_PLAN_BY_ID_ENDPOINT
                        .replace(AppConstants.LEAVE_ID_PLACEHOLDER, leaveId);
};

export const getUrlForAllLeavePlansForManagerByDate = (managerId, fromDate, toDate) => {
    const url = AppConstants.GET_LEAVE_PLANS_BETWEEN_FOR_MANAGER_ENDPOINT
                    .replace(AppConstants.MANAGER_ID_PLACEHOLDER, managerId)
                    .replace(AppConstants.FROM_DATE_PLACEHOLDER, getDateInFormat(fromDate))
                    .replace(AppConstants.TO_DATE_PLACEHOLDER, getDateInFormat(toDate));
    return url;
}

export const getUrlForAllLeavePlansForClientByDate = (clientId, fromDate, toDate) => {
    const url = AppConstants.GET_LEAVE_PLANS_BETWEEN_FOR_CLIENT_ENDPOINT
                    .replace(AppConstants.CLIENT_ID_PLACEHOLDER, clientId)
                    .replace(AppConstants.FROM_DATE_PLACEHOLDER, getDateInFormat(fromDate))
                    .replace(AppConstants.TO_DATE_PLACEHOLDER, getDateInFormat(toDate));
    return url;
}

export const getUrlForAllLeavePlansByDate = (fromDate, toDate) => {
    const url = AppConstants.GET_ALL_LEAVE_PLANS_BETWEEN_DATES_ENDPOINT
                    .replace(AppConstants.FROM_DATE_PLACEHOLDER, getDateInFormat(fromDate))
                    .replace(AppConstants.TO_DATE_PLACEHOLDER, getDateInFormat(toDate));
    return url;
}

export const getUrlForApproveLeavePlan = (leaveId) => {
    return AppConstants.APPROVE_LEAVE_PLAN_ENDPOINT
                        .replace(AppConstants.LEAVE_ID_PLACEHOLDER, leaveId);
};

export const getUrlForRejectLeavePlan = (leaveId) => {
    return AppConstants.REJECT_LEAVE_PLAN_ENDPOINT
                        .replace(AppConstants.LEAVE_ID_PLACEHOLDER, leaveId);
};